import React, { useEffect, useState } from "react";
import "./Loader.css";

/* =========================================================================
   [GIF LOADER - KEEP FOR FUTURE USE]
   When you receive the new GIF, simply uncomment the import and the GIF render block below.
   ========================================================================= */
// import loaderMedia from "../../Videos/LapLoadergif.gif";
// const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg", "mov"];
// function getExtension(src) {
//   const clean = src.split("?")[0];
//   return clean.split(".").pop().toLowerCase();
// }

const FULL_WORD = "LapStay";

export default function Loader({ isReady = false, minDisplayMs = 2200 }) {
  const [typedLength, setTypedLength] = useState(0);
  const [canHide, setCanHide] = useState(false);
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(false);

  // const isVideo = VIDEO_EXTENSIONS.includes(getExtension(loaderMedia));
  // const [mediaLoaded, setMediaLoaded] = useState(false);

  // Character-by-character typing interval
  useEffect(() => {
    if (typedLength < FULL_WORD.length) {
      const timeout = setTimeout(() => {
        setTypedLength((prev) => prev + 1);
      }, 120); // 120ms per character for natural typing cadence
      return () => clearTimeout(timeout);
    }
  }, [typedLength]);

  // Ensure loader stays visible for at least minDisplayMs
  useEffect(() => {
    const t = setTimeout(() => setCanHide(true), minDisplayMs);
    return () => clearTimeout(t);
  }, [minDisplayMs]);

  // Fade out once ready & min time passed
  useEffect(() => {
    if (isReady && canHide && !fading) {
      setFading(true);
      const t = setTimeout(() => setHidden(true), 500);
      return () => clearTimeout(t);
    }
  }, [isReady, canHide, fading]);

  if (hidden) return null;

  // Split currently typed characters into "Lap" (blue) and "Stay" (gold)
  const currentText = FULL_WORD.slice(0, typedLength);
  const lapChars = currentText.slice(0, 3).split("");
  const stayChars = currentText.slice(3).split("");
  const typingDone = typedLength >= FULL_WORD.length;

  return (
    <div
      className={`app-loader${fading ? " app-loader--fade" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="lapstay-loader-wrap">
        {/* Ambient Halo Aura (Blue & Gold) */}
        <div className="lapstay-loader-halo" />

        {/* Realtime Typing Typography */}
        <div className="lapstay-loader-brand">
          <span className="lap-part">
            {lapChars.map((ch, idx) => (
              <span key={`lap-${idx}`} className="char-typed">{ch}</span>
            ))}
          </span>
          <span className="stay-part">
            {stayChars.map((ch, idx) => (
              <span key={`stay-${idx}`} className="char-typed">{ch}</span>
            ))}
          </span>
          <span className={`lapstay-cursor ${typingDone ? "done" : "typing"}`}>|</span>
        </div>

        {/* Progress Line */}
        <div className={`lapstay-loader-line-track ${typingDone ? "show" : ""}`}>
          <div className="lapstay-loader-line-shimmer" />
        </div>

        {/* Luxury Tagline */}
        <div className={`lapstay-loader-tagline ${typingDone ? "show" : ""}`}>
          <span>LUXURY STAYS &amp; EXPERIENCES</span>
        </div>
      </div>

      {/* =================================================================
          [ORIGINAL GIF/VIDEO LOADER CODE - UNCOMMENT WHEN NEW GIF IS READY]
          =================================================================
      {isVideo ? (
        <video
          className="app-loader__video"
          src={loaderMedia}
          autoPlay
          loop
          muted
          playsInline
          onLoadedData={() => setMediaLoaded(true)}
        />
      ) : (
        <img
          className="app-loader__video"
          src={loaderMedia}
          alt="Loading"
          onLoad={() => setMediaLoaded(true)}
        />
      )}
      ================================================================= */}
    </div>
  );
}
